<template>
	<symbol :id="`${prefix}${slug}`" viewBox="0 0 16 16">
		<circle
			cx="8"
			cy="8"
			r="8"
			:fill="getColor('sign')"
			stroke="none"
		/>
		<rect
			x="5"
			y="7"
			width="6"
			height="2"
			:fill="getColor('icon')"
			stroke="none"
		/>
	</symbol>
</template>

<script>
export const slug = 'busy';


export default {
	name: 'NiIconBusy',


	props: {
		prefix: {
			type: String,
			required: true,
		},

		palette: {
			type: Object,
		},

		disabled: {
			type: Boolean,
			default: false,
		},
	},


	data() {
		return {
			slug,
		};
	},


	computed: {
		colors() {
			return {
				icon: this.$palette.white,
				sign: this.$palette.red,
				icon__disabled: this.$palette.white__disabled,
				sign__disabled: this.$palette.red__disabled,

				...this.palette,
			};
		},
	},


	methods: {
		getColor(color) {
			let bits = [
				color,
			];

			if (this.disabled) {
				bits.push('disabled');
			}

			return this.colors[bits.join('__')];
		},
	},
};
</script>
